import { Barcode, Wrench } from "lucide-react";
import { Skeleton } from "../skeleton/skeleton";

interface IFailureMTUListProps {
  failures?: {
    name: string;
    code: string;
    id: string;
  }[];
  mtus?: {
    code: string;
    id: string;
  }[];
  mtusPending?: boolean;
  failuresPending?: boolean;
}

export function FailureMTUList({
  failures,
  mtus,
  failuresPending,
  mtusPending,
}: IFailureMTUListProps) {
  return (
    <div className="grid grid-cols-2 gap-x-4 ">
      <div className="flex flex-col gap-2 border-none bg-card rounded-2xl p-4 h-full overflow-auto max-h-36">
        {failuresPending &&
          [...Array(3)].map((_, i) => (
            <Skeleton className="h-[24px] w-full" key={i} />
          ))}
        {failures?.map((failure) => (
          <div key={failure.id} className="flex gap-1.5 items-start text-sm">
            <Wrench className="flex-shrink-0" strokeWidth={1.25} />
            <span className="inline-block font-semibold">{failure.code}</span>
            {failure.name}
          </div>
        ))}
      </div>
      <div className="flex flex-col gap-2 border-none bg-card rounded-2xl p-4 h-full overflow-auto max-h-36">
        {mtusPending &&
          [...Array(3)].map((_, i) => (
            <Skeleton className="h-[24px] w-full" key={i} />
          ))}
        {mtus?.map((mtu) => (
          <div key={mtu.id} className="flex gap-2.5 text-sm items-center">
            <Barcode className="flex-shrink-0" strokeWidth={1.25} />
            {mtu.code}
          </div>
        ))}
      </div>
    </div>
  );
}
